var map = {
	"./1.png": "1039",
	"./10.png": "a3b4",
	"./11.png": "399f",
	"./12.png": "e8e0",
	"./15.png": "5f60",
	"./16.png": "64d9",
	"./17.png": "13a7",
	"./19.png": "19ff",
	"./2.png": "8f53",
	"./20.png": "d7a9",
	"./22.png": "0644",
	"./23.png": "e5ca",
	"./3.png": "ba56",
	"./4.png": "8e23",
	"./7.png": "3808",
	"./8.png": "ae99",
	"./9.png": "be8f",
	"./Daniel.png": "cf5e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "271c";